import { Navigate } from 'react-router-dom'
import { tenantConfig } from '@/lib/tenant'
import { useDevAuth, DevSignInPanel } from './dev'
import { useClerkAuth, ClerkSignInPanel, ClerkSignUpPanel, ClerkSsoCallback } from './clerk'
import { AuthRootProvider } from './provider'

export type { AuthContext } from './dev'
export type { AuthUser, UserRole } from './store'
export { getAuthToken } from './store'
export { AuthRootProvider }

const useAuthImpl =
  tenantConfig.authProvider === 'clerk' ? useClerkAuth : useDevAuth

/**
 * Provider-agnostic auth hook. All app code imports auth from here only.
 *
 * ESLint rule note: real Clerk imports must stay in src/lib/auth/ only.
 */
export function useAuth() {
  return useAuthImpl()
}

export function SignInPanel() {
  if (tenantConfig.authProvider === 'clerk') {
    return <ClerkSignInPanel />
  }
  return <DevSignInPanel />
}

export function SignUpPanel() {
  if (tenantConfig.authProvider === 'clerk') {
    return <ClerkSignUpPanel />
  }
  // dev provider has no separate registration; reuse the dev sign-in form
  return <DevSignInPanel />
}

/** Public OAuth/SSO return route. Clerk finalizes here; dev has no OAuth. */
export function SsoCallback() {
  if (tenantConfig.authProvider === 'clerk') {
    return <ClerkSsoCallback />
  }
  return <Navigate to="/login" replace />
}
